<template>
<div class="sendNoticeVue">
 <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <!-- Heading Section -->
            <!-- <div class="row c-responsive-fixwidth">
                <div class="col-md-12">
                    <h1 class="h1 text-center">Send Notice</h1>
                </div>
            </div> -->
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->

        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="col-md-6 col-md-offset-1">
                <div class="col-md-12">
                    <h1 class="h1 text-center">Send Notice</h1>
                </div>
                <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">To:</label>
                                <div class="row">
                                    <div class="col-sm-8">
                                        <el-select
                                        v-model="sendNotice.sendid"
                                        :disabled="allSelectedTo"
                                        multiple
                                        collapse-tags
                                        v-validate="{required: true}"
                                        name="sendid"
                                        class="customAllSelect"
                                        style="width: 100%;"
                                        placeholder="Select Client">
                                            <el-option
                                              class="toSelected"
                                              v-for="client in clients"
                                              :key="client.id"
                                              :label="client.user.display_name"
                                              :value="client.user.email">
                                              <span style="float: left">{{client.user.display_name}}</span>
                                              <span style="float: right; margin-right: 22px; color: #8492a6; font-size: 13px">{{client.user.email}}</span>
                                            </el-option>
                                        </el-select> 
                                    </div> 
                                    <div class="col-sm-4">
                                        <input type="checkbox" @change="selectAllClient('To')" v-model="allSelectedTo" name="clientTo">  All Client
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Bcc:</label>
                                <div class="row">
                                    <div class="col-sm-8">
                                        <el-select
                                        :disabled="allSelectedBcc"
                                        v-model="sendNotice.bcc"
                                        multiple
                                        collapse-tags
                                        name="bcc"
                                        class="customAllSelect"
                                        style="width: 100%;"
                                        placeholder="Select Client">
                                            <el-option
                                             class="toSelected"
                                              v-for="client in clients"
                                              :key="client.id"
                                              :label="client.user.display_name"
                                              :value="client.user.email">
                                              <span style="float: left">{{client.user.display_name}}</span>
                                              <span style="float: right; margin-right: 22px; color: #8492a6; font-size: 13px">{{client.user.email}}</span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="col-sm-4">
                                        <input type="checkbox" @change="selectAllClient('Bcc')" v-model="allSelectedBcc" name="clientBcc">  All Client
                                    </div>
                                </div>
                                    
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Subject:</label>
                                <input type="text" class="form-control" placeholder="Subject of the message" v-validate="{ required: true}" name="subject" v-model="sendNotice.subject">
                                <span v-show="errors.has('subject') && this.validation_err!=0" class="err-msg">{{ errors.first('subject') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Message:</label>
                                <textarea class="form-control u-border-radius-0" rows="3" placeholder="" v-validate="{ required: true}" name="message" v-model="sendNotice.message"></textarea>
                                <span v-show="errors.has('message') && this.validation_err!=0" class="err-msg">{{ errors.first('message') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                               <label class="common-label-text o-super-label">Attach Your Files:</label>
                                <div v-for="(file, key) in files" class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                    <button class="btn c-common-btn c-common-btn--small">Choose File</button>
                                    <input @change="attachmentAdded($event)" type="file" name="myfile" />
                                     <span>{{(attachment)? snippet(attachment.name) : 'No file chosen'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-center">
                                <ul class="o-filter-area">
                                    <li>
                                        <a href="javascript: void(0)" @click="backToDashboard()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                    </li>
                                    <li>
                                        <a href="javascript: void(0)" @click="sendNoticeTrigger()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Send</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div class="col-md-3">                
                <div class="col-md-12">
                    <h1 class="h1 text-center">@callsteward remainder</h1>
                </div>
                <div class="loading-effect" v-loading="sms_send_loading">
                    <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                        <div class="row">
                            <div class="col-sm-12">
                                <!-- <div class="text-center"> -->
                                    <ul class="o-filter-area mb-10">
                                        <li>
                                            <a href="javascript: void(0)" disabled="clients_count" @click="sendSmsToAll()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue">Send</a>
                                        </li>
                                        
                                    </ul>
                                <!-- </div> -->
                            </div>
                            <div class="col-sm-12">
                                <p class="mb-10">
                                    SMS to all <span v-if="bab_emails_count || bab_emails_count==0">{{ bab_emails_count }} </span> active
                                </p>
                                <p class="mb-10">
                                    @callsteward.com with a cell phone on file
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
</div>

</template>
<script>
    import {
        bus
    } from '../../main';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';

    export default {
        data() {
            return {
                bab_emails_count: 0,
                sms_send_loading: false,
                validation_err: 0,
                files: [{
                    file: 'No file chosen'
                }, ],
                attachment:null,
                sendNotice: {
                    sendid:[],
                    subject: '',
                    message: '',
                    bcc:[],    
                },
                allSelectedTo: true,
                allSelectedBcc: true,
                clients: []
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken'
            }),
            update_bad_email_count() {
                return bab_emails_count
            }
        },
        methods: {
            async sendSmsToAll() {
                // console.log("Get SMS");
                this.$Progress.start();
                this.sms_send_loading = true;
                await service.get('superadmin/notify-bad-email', {
                                'Authorization': this.userToken
                            })
                    .then((res) => {
                            // this.sms_send_loading = false;
                            // this.bab_emails_count = res.data.result;
                            // console.log(res.data);
                            this.$Progress.finish();
                            this.$notify({
                                title: this.$t('success'),
                            type: 'success',
                            message: 'SMS send successfully'
                        });
                    }).catch((err) => {
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Sorry! something went wrong.',
                            type: 'error'
                        });
                    });
                this.sms_send_loading = false;
                this.$Progress.finish();

            },

            async getActiveClientsCount() {
                this.sms_send_loading = true;
                await service.get('superadmin/generate-bad-email', {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        this.bab_emails_count = res.data.result;           
                        // console.log(this.bab_emails_count);
                    }).catch((err) => {
                        console.log(err);
                    });
                this.sms_send_loading = false;
            },

            attachmentAdded($event)
            {
              if($event.target.files.length != 0)
                this.attachment = $event.target.files[0];
              else
                 this.attachment = null;
              //console.log(this.attachment.name);
            },
            selectAllClient(type) {
                //console.log(type);
                if(type=='To'){
                    if(this.allSelectedTo==true){
                        for (var i = 0; i < this.clients.length; i++) {
                            this.sendNotice.sendid.push(this.clients[i].user.email);
                            //console.log(this.clients[i].user.email);
                        }
                        //console.log(this.sendNotice.sendid);
                    }else{
                        this.sendNotice.sendid=[];
                    }
                }else{
                    if(this.allSelectedBcc==true){
                        for (var i = 0; i < this.clients.length; i++) {
                            this.sendNotice.bcc.push(this.clients[i].user.email);
                        }
                    }else{
                        this.sendNotice.bcc=[];
                    }
                }
            },
            backToDashboard() {
                this.$router.push({
                    'path': '/clientList'
                });
            },
            sendNoticeTrigger() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        var formData = new FormData();
                        formData.append('subject', this.sendNotice.subject);
                        formData.append('body', this.sendNotice.message);
                        formData.append('to', this.sendNotice.sendid);
                        if(this.sendNotice.bcc.length>0){
                            formData.append('bcc', this.sendNotice.bcc);
                        }
                        if(this.attachment != null || this.attachment == "")
                        {
                          formData.append("attachment", this.attachment);
                        }
                        service.post('client/sendNoticeEmail', formData, {
                                'Authorization': this.userToken
                            })
                            .then((res) => {
                                this.$notify({
                                    title: this.$t('success'),
                                    message: 'Email send successfully',
                                    type: 'success'
                                });
                                this.sendNotice = {
                                    sendid: '',
                                    subject: '',
                                    message: '',
                                    bcc: ''
                                };
                                this.attachment == null;

                            }).catch((err) => {
                                this.$notify({
                                    title: this.$t('error'),
                                    message: 'Sorry! something went wrong.',
                                    type: 'error'
                                });
                            });


                        //console.log(fromData);
                    } else {
                        this.validation_err = 1;
                        console.log("error");
                    }
                });
            },
            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
            },
            snippet(value) {
                if (value.length > 70)
                    return value.slice(0, 70) + ' ...';
                else
                    return value;
            },
        },
        async created() {
            this.$Progress.start();
            await this.getActiveClientsCount();
            service.get('client', {
                'Authorization': this.userToken
            })
            .then((res) => {
                this.$Progress.finish();
                //console.log("client", res.data.result.data);
                this.clients = res.data.result;
                for (var i = 0; i < this.clients.length; i++) {
                    this.sendNotice.sendid.push(this.clients[i].user.email);
                    this.sendNotice.bcc.push(this.clients[i].user.email);
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }

</script>
<style scoped>

.loading-effect {
    min-height: 100px;
}

.mb-10 {
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/superAdmin/clientSendNotice.vue